import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3400, { U3400ROLES } from './U3400';
import U3400DashboardScreen from './components/U3400DashboardScreen';

const U3400Routes: RouteObject[] = [
  {
    path: 'U3400',
    element: <U2000RequireRole allowedRoles={[U3400ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3400 />,
        children: [{ index: true, element: <U3400DashboardScreen /> }],
      },
    ],
  },
];

export default U3400Routes;
